<template>
  <div class="custom-filter">
    <div
      style="padding-left: 16px;height: 42px;color: #969799;font-size: 12px;line-height: 42px;"
      class="van-hairline--top"
    >
      * 最多可选择4项，最少选择1项
    </div>
    <van-grid column-num="3" :border="false" gutter="16">
      <van-grid-item use-slot v-for="item in tagList" :key="item.title">
        <div
          class="filter-tag van-multi-ellipsis--l2 flex-center"
          :class="{ active: item.active }"
          @click="filter(item)"
        >
          {{ item.alias || item.title }}
        </div>
      </van-grid-item>
    </van-grid>
    <div style="padding-top: 11px;">
      <div v-for="item in activeList" :key="item.title" class="introduce">
        * {{ item.alias || item.title }}：{{ item.introduce }}
      </div>
    </div>
    <div style="height: 20px;"></div>
    <div
      class="flex-center"
      style="padding:0 16px 24px 16px;justify-content:space-between;"
    >
      <van-button color="#2F80ED" plain style="width: 164px;" @click="select"
        >取消</van-button
      >
      <van-button color="#2F80ED" style="width: 164px;" @click="select"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columnData: {
      type: Array,
      default: function() {
        return []
      },
    },
    showDemo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagList: [],
      fistColumn: {},
      activeList: [],
    }
  },
  mounted() {
    this.fistColumn = this.columnData[0]
    this.tagList = Object.assign(
      [],
      this.columnData.slice(1, this.columnData.length)
    )
    this.activeList = this.tagList.filter((item) => item.active)
    if (this.showDemo) {
      this.tagList.push(
        ...[
          {
            title: '动销金额',
            disabled: true,
          },
          {
            title: '潜客跟进率',
            disabled: true,
          },
        ]
      )
    }
  },
  methods: {
    filter(item) {
      if (item.disabled) {
        return this.$Toast('敬请期待')
      }
      let select = this.tagList.filter((item) => item.active)
      if (select.length > 3) {
        if (!item.active) {
          return this.$Toast('最多选择4项数据')
        } else {
          item.active = false
        }
      } else {
        if (select.length === 1 && item.active) {
          return this.$Toast('最少选择1项数据')
        }
        item.active = !item.active
      }
      // console.log(select)
      this.activeList = this.tagList.filter((item) => item.active)
      this.$emit('getFilter', [
        this.fistColumn,
        ...this.tagList.filter((item) => item.active),
      ])
    },
    select() {
      this.$emit('ok')
    },
  },
}
</script>

<style lang="less" scoped>
.custom-filter {
  /deep/.van-grid-item__content {
    padding: 0;
  }
}
.filter-tag {
  width: 100%;
  height: 32px;
  background: #f7f8fa;
  border-radius: 64px;
  justify-content: center;
  font-size: 12px;
  color: #000;
}
.active {
  border: 1px solid #2f80ed;
  background: rgba(47, 128, 237, 0.1);
  color: #2f80ed;
}
.introduce {
  font-size: 12px;
  line-height: 20px;
  color: #969799;
  margin-bottom: 4px;
  padding: 0 16px;
}
</style>
